import { useNavigate } from "react-router";
import { useAtom, useAtomValue } from "jotai";
import { AppStateAtom, SidebarStateAtom } from "../../store";
import { SelectedFundAtom } from "../../store/FundStateAtom";
import { SelectedReportingPeriodAtom } from "../../store/ReportingPeriodStateAtom";
import { useEffect, useState } from "react";

export const useNavbarController = () => {
  const navigate = useNavigate();
  const appState = useAtomValue(AppStateAtom);
  const isUserAdmin = appState.user?.role === "admin";

  const selectedFund = useAtomValue(SelectedFundAtom);
  const selectedReportingPeriod = useAtomValue(SelectedReportingPeriodAtom);
  const isFundSelected = !!selectedFund?.fundId;
  const isReportingPeriodSelected = !!selectedReportingPeriod;

  const [isCollapsed, setIsCollapsed] = useAtom(SidebarStateAtom);
  const [collapsedGroups, setCollapsedGroups] = useState<
    Record<string, boolean>
  >({});

  // Load collapsed groups state from localStorage
  useEffect(() => {
    const savedCollapsedGroups = localStorage.getItem("collapsedGroups");
    if (savedCollapsedGroups) {
      try {
        setCollapsedGroups(JSON.parse(savedCollapsedGroups));
      } catch (error) {
        console.error(
          "Error parsing collapsed groups from localStorage:",
          error
        );
      }
    }

    setIsCollapsed(false); //Temp
  }, []);

  const toggleSidebar = () => {
    setIsCollapsed((prev: boolean) => {
      const newState = !prev;
      localStorage.setItem("collapsed", JSON.stringify(newState));
      return newState;
    });
  };

  const toggleGroupCollapse = (groupLabel: string) => {
    setCollapsedGroups((prev) => {
      const newState = {
        ...prev,
        [groupLabel]: !prev[groupLabel],
      };
      localStorage.setItem("collapsedGroups", JSON.stringify(newState));
      return newState;
    });
  };

  return {
    isCollapsed,
    toggleSidebar,
    navigate,
    isUserAdmin,
    isFundSelected,
    isReportingPeriodSelected,
    collapsedGroups,
    toggleGroupCollapse,
  };
};
